import React from 'react';
import TableCell from '@components/TableCell';
import get from 'lodash-es/get';

import { stripePriceConverter } from '@services/transform';
import { COUPON_TYPES, TIME_FRAME_TITLES } from '@services/minte';
import { isWithin24Hours } from '@utils/date';

export const renderAddons = (addons, appData, propertyInfo) => {
  if (!addons || !addons.length) {
    return null;
  }
  return addons.map(addOn => {
    const addonData = appData.addons[addOn];
    const { title } = addonData;
    const price = get(propertyInfo, `addons.${addOn}`, 0);

    return (
      <TableCell
        key={addOn}
        title={title}
        rightText={`$${stripePriceConverter(price)}`}
      />
    );
  });
};

export const renderServiceItem = (
  appData,
  property,
  serviceType,
  addons,
  momentDate,
  cost,
  discountDetails,
  couponDetails,
  paymentMethod,
  timeframe,
  onShowTimeModal
) => {
  const { serviceTypes } = appData;
  const { title } = serviceTypes[serviceType];

  const propertyInfo = get(appData, `properties.${property.propertyID}`, {});
  const price = get(propertyInfo, `serviceTypes.${serviceType}`, 0);

  const totalPrice = `$${stripePriceConverter(cost)}`;

  const { off: recurringDiscountValue, type: recurringDiscountType } =
    discountDetails || {};
  const { off: couponOff, valueOff: couponValue, type: couponType } =
    couponDetails || {};

  const isServiceWithin24hours = isWithin24Hours(momentDate);
  const formattedServiceDate = momentDate.format('MMM DD');
  const chargeDate = momentDate
    .clone()
    .subtract(1, 'day')
    .format('MMM DD');

  return (
    <React.Fragment>
      <TableCell title={title} rightText={`$${stripePriceConverter(price)}`} />
      {renderAddons(addons, appData, propertyInfo)}
      {!isNaN(recurringDiscountValue) && (
        <TableCell
          title="Package discount"
          rightText={
            recurringDiscountType === COUPON_TYPES.FIXED_AMOUNTINGLE
              ? `$${stripePriceConverter(recurringDiscountValue)}`
              : `${recurringDiscountValue}%`
          }
        />
      )}
      {!isNaN(couponValue) && (
        <TableCell
          title="Discount"
          rightText={
            couponType === COUPON_TYPES.FIXED_AMOUNTINGLE
              ? `$${stripePriceConverter(couponValue)}`
              : `${couponOff}%`
          }
        />
      )}
      <TableCell title="Total*" rightText={totalPrice} />
      <TableCell
        title="Service time"
        rightText={TIME_FRAME_TITLES[timeframe]}
        rightIcons={[timeframe]}
        rightIconColor="gold"
        disabled={isServiceWithin24hours}
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          if (onShowTimeModal) {
            onShowTimeModal();
          }
        }}
      />
      <TableCell title="Service date" rightText={formattedServiceDate} />
      {paymentMethod !== 'invoice' && (
        <TableCell title="Charge date" rightText={chargeDate} />
      )}
    </React.Fragment>
  );
};
